<script setup></script>

<template>
  <PostContentDisclaimer is-addition />
</template>
